'use strict';
const normalisedIdentifier = require('@mindmup/js-utils/src/normalised-identifier'),
	OAuthPKCEShim = require('./oauth-pkce-shim'),
	TokenParser = require('./token-parser'),
	PKCEUtils = require('./pkce-utils'),
	PopupLauncher = require('./popup-launcher'),
	microsoftOauthParams = require('./microsoft-oauth-params');
module.exports = function MicrosoftAuthShim(config, navigatorShim, ajaxPromise, logger = console) {
	if (!config || !ajaxPromise || !navigatorShim) {
		throw new Error('invalid-args');
	}
	const tokenParser = new TokenParser(),
		pkceUtils = new PKCEUtils({navigatorShim, clientId: config.client_id, interactionRequiredErrors: microsoftOauthParams.interactionRequiredErrors, ajaxPromise, logger}),
		popupLauncher = new PopupLauncher({navigatorShim}),
		oauthPKCEShim = new OAuthPKCEShim(Object.assign({
			scope: config.scope,
			clientId: config.client_id,
			endpointUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/',
			navigatorShim,
			ajaxPromise,
			popupLauncher,
			pkceUtils,
			logger
		}, microsoftOauthParams)),
		getUserInfo = (token) => {
			return ajaxPromise.get('https://graph.microsoft.com/v1.0/me', {
				headers: {'Authorization': 'Bearer ' + token}
			})
			.then(message => {
				if (message.error) {
					throw message.error;
				}
				return {
					id: message.id,
					email: normalisedIdentifier(message.userPrincipalName)
				};
			});
		},
		getOrganisation = (token) => {
			const parsed = tokenParser.parseJWT(token),
				tenant = parsed?.tid;
			if (!tenant) {
				return {};
			}
			return ajaxPromise.get('https://graph.microsoft.com/v1.0/organization', {
				headers: {'Authorization': 'Bearer ' + token}
			})
			.then(response =>  {
				const organization = response && response.value && response.value[0],
					domain = organization && organization.verifiedDomains && organization.verifiedDomains.length && (organization.verifiedDomains.find(d => d.isDefault) || organization.verifiedDomains[0]);
				if (domain) {
					return {domain: normalisedIdentifier(domain.name), orgId: organization && organization.id};
				}
				return {};
			});
		},
		getUserProfile = async function (token, requestedUserId) {
			const profile = await getUserInfo(token).catch(() => {
					throw 'networkError';
				}),
				allowedIdentifiers = [profile.id, profile.email].map(normalisedIdentifier);
			if (!profile || !profile.id) {
				throw 'networkError';
			} else if (requestedUserId  && !allowedIdentifiers.includes(normalisedIdentifier(requestedUserId))) {
				throw 'userIdMismatch';
			} else {
				const orgInfo = await getOrganisation(token);
				return Object.assign(profile, {token}, orgInfo);
			}
		};
	Object.assign(this, {
		getUserProfile
	}, oauthPKCEShim);
};

